import { css } from '@migros/msrc-ui-kit';
import { isMigipediaDarkTheme } from '../../../helpers/migipedia-themes';
export const migipediaRatingStyles = css`
  color: ${({
  active,
  theme: {
    themeId,
    colors
  }
}) => active ? colors.brand.accent[100] : isMigipediaDarkTheme(themeId) ? colors.tints.gray[50] : colors.tints.gray[25]};
  &:hover {
    color: ${({
  active,
  editable,
  theme: {
    colors
  }
}) => editable && !active && colors.brand.accent[100]};
  }
`;